module.exports = function indexOf(item, arr) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] === item) {
			return i;
		}
	}
	return -1;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/array/indexOf.js
 ** module id = 16
 ** module chunks = 0
 **/